import React, { useEffect, useState } from 'react';
import { Header } from '../../components/Header';

import { Content, Container } from './styles';
import { WeekGraph } from '../../components/weekGraph';
import { Rank } from '../../components/Rank';
import { CountDown } from '../../components/CountDown';
import { ProgressTable } from '../../components/ProgressTable';

import {db} from "../../firebase";
import { collection, getDocs } from "firebase/firestore";

import { useGlobal } from '../../contexts/GlobalContext';
import jojo from "../../assets/jotaro.png"; 


export const Home = () => {

    const { weekRank, generalRank } = useGlobal();
    const [ weekData, setWeekData ] = useState([]);
    const [ generalData, setGeneralData ] = useState([]);

    useEffect(() => {
        setWeekData([...weekRank]);
        setGeneralData([...generalRank]);
    }, [weekRank, generalRank]);

    return (
        <Container>
            <Header/>
            <Content>
                <div style={{display: "flex", alignItems:"center", justifyContent: "center", width: "100%", marginBottom: "2rem"}}>
                    <img src={ jojo } width="400px" alt="jojo" />
                </div>
                <h3>Projeto JoJo - 8 semanas</h3>
                <CountDown/>
                <h3>Tabela da verdade</h3>
                <ProgressTable/>
                <h3>Progresso do pae</h3>
                <WeekGraph />
                <h3>Ranking Semanal dos crias</h3>
                <Rank dataArray={ weekData } week={true}/>         
                <h3>Ranking Geral da rapazeada</h3>
                <Rank dataArray={ generalData } week={false}/>         
            </Content>
        </Container>
    );
};
